// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3wfj-","errorLogs":"EditorFooter_errorLogs__VEojQ"};